export const TYPES_HEBERGEMENT = [
    { id: 'A', description: "Autre" },
    { id: 'AC', description: "Activité" },
    { id: 'AB', description: "Auberge" },
    { id: 'CA', description: "Camp" },
    { id: 'CP', description: "Camping" },
    { id: 'MI', description: "Maison" },
    { id: 'MA', description: "Manoir" },
    { id: 'PA', description: "Pavillon" },
    { id: 'CH', description: "Chalet" },
    { id: 'PC', description: "Prt-à-Camper" },
    { id: 'QU', description: "Quai" },
]

export const ENSOLEILLEMENT = [
    { id: 0, description: "Ombrage" },
    { id: 1, description: "Mi-ombre" },
    { id: 2, description: "Plein soleil" },
    { id: 3, description: "Ombre matin et soleil après-midi" },
    { id: 4, description: "Soleil matin et ombre après-midi" },
]